import React from "react";
import classNames from "classnames";

const Button = ({
    text = "Button",
    onClick,
    config = {},
}) => {
    const {
        type = "primary", // 'primary' = Sign Up, 'secondary' = Login
        width = "w-[100px]",
        disabled = false,
    } = config;

    const baseClasses = `
        text-base font-semibold rounded-md
        transition-all duration-200 ease-in-out
        py-2 px-4 border
        active:scale-95 active:ring-2 active:ring-offset-1 active:ring-[#04236B]
    `;

    const primaryClasses = `
        bg-white text-[#04236B] border-[#04236B]
        hover:bg-[#04236B] hover:text-white
    `;

    const secondaryClasses = `
        bg-[#04236B] text-white border-[#04236B]
        hover:bg-white hover:text-[#04236B]
    `;

    return (
        <button
            className={classNames(
                baseClasses,
                width,
                type === "primary" ? primaryClasses : secondaryClasses
            )}
            onClick={onClick}
            disabled={disabled}
        >
            {text}
        </button>
    );
};

export default Button;
